var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticStyle:{"float":"right"},attrs:{"small":"","color":"white","outlined":""},on:{"click":function($event){return _vm.$router.push({ name: ("Create " + _vm.object) })}}},[_c('v-icon',[_vm._v(" mdi-plus ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }